//packages
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
//global components
import MainMenu from '../../_components/MainMenu';
import MainFooter from '../../_components/MainFooter';

import PreLoader from "../../_components/PreLoader";
// import SocialMedia from '../../_components/SocialMedia';

import PageNotFound from '../../_components/PageNotFound';
//services
import { menuService } from '../../_services/menu.service';
import { postService } from '../../_services/post.service';
//styles
import './Page.sass';

class Page extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      user: {
        details: {}
      },
      menu: {
        items: []
      },
      topbarMenu: {},
      page: {},
      branches: [],
      notFound: false
    };
  }

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem('user'));
    const slug = this.props.match.params[0];
    if (user && Date.now() < user.expiresAt) {
      this.setState({
        user: user
      });
    } else {
      this.setState({
        user: {
          details: {}
        }
      });
    }

    Promise.allSettled([
      postService.getBySlug(slug).then(
        page => {
          if (page.length > 0) {
              this.setState({ page: page[0]})
          } else {
            this.setState({ notFound: true })
          }
        }
      ),
      menuService.getMenuByName('default').then(menu => this.setState({ menu })),
      menuService.getMenuByName('Topbar').then(topbarMenu => this.setState({ topbarMenu })),
      postService.getBranchesFooter('branch').then(branches => this.setState({ branches }))
    ]).then(() => this.setState({ loading: false }))
  }

  render() {
    const { loading, user, menu, topbarMenu, page, notFound, branches } = this.state;
  
    return (
      <>
        <PreLoader loading={loading} />
        {!notFound ?
          <div className="page-container">
            <MainMenu user={user} menu={menu} topbarMenu={topbarMenu}/>
            <div className="jumbotron page-title py-5">
              <div className="container"><h1 className="text-white bolder ">{page.title ? page.title.rendered : ''}</h1></div>
            </div>
            {Object.keys(page).length > 0 ?
            <>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-transparent m-0">
                      <li className="breadcrumb-item"><a href="/">Home</a></li>
                      <li className="breadcrumb-item active" aria-current="page">{page.title ? page.title.rendered : ''}</li>
                    </ol>
                  </nav>
                </div>
                <div className="col-12">
                  <hr className="m-0 mb-4" />
                </div>
              </div>
            </div>
            <Container>
                <Row>
                  <Col md={12}>
                    <div dangerouslySetInnerHTML={{ __html: page.content.rendered }} />
                  </Col>
                </Row>

            </Container>
            </>
          :
          ""
          }
          <MainFooter menu={menu} branches={branches} />
          </div>
        :
          <PageNotFound />
        }
        
      </>
    );
  }
}

export { Page };